import React from 'react'
import CardTwo from '../card-two/CardTwo'
import './sectionThree.css'

function SectionThree() {
    return (
        <div className="sectionThree__main">
            <div className="sectionThree__tagline">
                <div  data-aos='zoom-out-down'  className="tagline">
                Charis COding Club
                </div>
            </div>
            <div  data-aos='zoom-out-down'  className="sectionThree__heading">
                <div className="head__two">
                Why Entrust Your Child with Us?
                </div>
            </div>
            <div  data-aos='zoom-out-down'  className="sectionThree__bottom">
                <CardTwo 
                heading='One on one classes'
                text='One on one classes available for children that want to learn flexibly at their own pace' />
                <CardTwo
                heading='Project Based Learning'
                text='learn the fundamentals of programming by working on interesting projects'/>
                <CardTwo 
                heading='Professional Tutors'
                text='Experienced and Professional tutuors who are graduates in STEM courses'
                />
                <CardTwo
                heading='Worldclass Curriculum'
                text='Get world class curriculum comparable to worldwide standards.'
                />
            </div>
        </div>
    )
}

export default SectionThree
